import { type SelectInputSize, SelectInputView, type SelectOption } from "./SelectInputView";

interface SelectInputProps {
  id?: string;
  name?: string;
  value: string;
  options: SelectOption[];
  placeholder?: string;
  label?: string;
  error?: string;
  disabled?: boolean;
  required?: boolean;
  /** `compact` matches in-app 14px form density; `default` is the roomier auth-funnel sizing. */
  size?: SelectInputSize;
  onChange: (value: string) => void;
  onBlur?: (e: React.FocusEvent<HTMLSelectElement>) => void;
  className?: string;
  validate?: (value: string) => string | undefined;
}

export const SelectInput = ({
  value,
  options,
  onChange,
  validate,
  error: externalError,
  ...props
}: SelectInputProps) => {
  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const newValue = e.target.value;
    onChange(newValue);
  };

  const handleBlur = (e: React.FocusEvent<HTMLSelectElement>) => {
    if (validate) {
      // Validation error would be handled by parent component
      validate(e.target.value);
    }
    props.onBlur?.(e);
  };

  const error = externalError;

  return (
    <SelectInputView
      {...props}
      value={value}
      options={options}
      onChange={handleChange}
      onBlur={handleBlur}
      error={error}
    />
  );
};
